import React from "react";

/* Wrapper for react-pin-input pincode fields — replaces legacy uiComponents/ReactPin. */

const baseStyles = `
.tk-pin-input .pincode-input-container .pincode-input-text {
  padding: 0 !important;
  margin: 0 8px !important;
  text-align: center;
  border: 2px solid color-mix(in srgb, var(--slate) 50%, transparent) !important;
  background: color-mix(in srgb, var(--slate) 50%, transparent) !important;
  width: 96px !important;
  height: 96px !important;
  border-radius: 8px;
  font-size: 28px !important;
  font-weight: 700 !important;
  color: var(--mint);
  font-family: var(--font-sans);
}
.tk-pin-input .pincode-input-container .pincode-input-text[value=""] {
  border-width: 1px !important;
}
.tk-pin-input .pincode-input-container .pincode-input-text:focus,
.tk-pin-input .pincode-input-container .pincode-input-text[value=""]:focus {
  outline: none;
  box-shadow: none;
  border-color: color-mix(in srgb, var(--slate) 50%, transparent) !important;
  background: color-mix(in srgb, var(--slate) 50%, transparent) !important;
}
[data-theme="light"] .tk-pin-input .pincode-input-container .pincode-input-text,
.tk-pin-input.theme-light .pincode-input-container .pincode-input-text {
  background: transparent !important;
  color: var(--text-strong) !important;
  border-color: var(--border) !important;
}
[data-theme="light"] .tk-pin-input .pincode-input-container .pincode-input-text:focus,
[data-theme="light"] .tk-pin-input .pincode-input-container .pincode-input-text[value=""]:focus,
.tk-pin-input.theme-light .pincode-input-container .pincode-input-text:focus,
.tk-pin-input.theme-light .pincode-input-container .pincode-input-text[value=""]:focus {
  background: transparent !important;
  color: var(--text-strong) !important;
}
.tk-pin-input.error .pincode-input-container .pincode-input-text,
.tk-pin-input.error .pincode-input-container .pincode-input-text:focus {
  border: 2px solid var(--red) !important;
}
.tk-pin-input.disabled .pincode-input-container .pincode-input-text {
  pointer-events: none;
  opacity: 0.5;
  background: var(--grey-bg) !important;
  border-color: var(--grey-mid) !important;
}
.tk-pin-input.remove-margin {
  margin-top: 24px;
}
.tk-pin-input:not(.remove-margin) {
  margin-top: 50px;
}
`;

const compactStyles = `
.tk-pin-input.compact .pincode-input-container .pincode-input-text {
  width: 48px !important;
  height: 48px !important;
  background: transparent !important;
  font-size: 26px !important;
  margin: 0 4px !important;
  color: var(--text-strong) !important;
  border: 2px solid var(--border) !important;
}
.tk-pin-input.compact .pincode-input-container .pincode-input-text:focus,
.tk-pin-input.compact .pincode-input-container .pincode-input-text[value=""]:focus {
  background: transparent !important;
  color: var(--text-strong) !important;
}
`;

export function PinInput({ children, error, className = "", compact = false, style, ...rest }) {
  const classes = [
    "tk-pin-input",
    error ? "error" : "",
    className,
    compact ? "compact" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <style>{baseStyles + compactStyles}</style>
      <div className={classes} style={style} {...rest}>
        {children}
      </div>
    </>
  );
}

export default PinInput;
